module.exports = __webpack_public_path__ + "img/total-orders.70c2b790.svg";